export const eventTypes = [
    "Engine On",
    "Engine Off",
    "Main Power Cut Off",
    "Main Power Good",
    "AC On",
    "AC Off",
    "Zone In",
    "Zone Out",
    "Generator On",
    "Generator Off",
    "Overspeed",
    "Door Open",
    "Door Close",
    "Compressor On",
    "Compressor Off",
    "Blower On",
    "Blower Off",
    "Panic",
    "Temp",
    "Locked",
    "Unlocked",
    "FASTag",
    "Fuel Filled",
    "Fuel Removed",
];

export const eventCollection = [
    "Engine",
    "Power",
    "AC",
    "Zone",
    "Fuel",
    "Generator",
    "Gen Wire",
    "Overspeed",
    "Door",
    "Compressor",
    "Blower",
    "Panic",
    "Temp",
    "Lock",
    "FASTag",
];